import { colors } from '@globals/themes/defaultTheme'
import EmojiObjectsOutlinedIcon from '@mui/icons-material/EmojiObjectsOutlined'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { ReactNode } from 'react'

type HelpTextProps = {
  helpText: ReactNode
  mt?: number
}

const HelpText: React.FC<HelpTextProps> = ({ helpText, mt = 0 }) => {
  return (
    <Stack
      spacing={0}
      direction="row"
      sx={{
        alignItems: 'flex-start',
        mt,
      }}>
      <EmojiObjectsOutlinedIcon sx={{ color: colors.goldPrimary }} />
      <Typography variant="caption" sx={{ color: colors.grayDark }}>
        {helpText}
      </Typography>
    </Stack>
  )
}

export default HelpText
